import type { CitationSourceLinkProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

export const CitationSourceLink = (props: CitationSourceLinkProps) => {
  return (
    <LazyComponent<CitationSourceLinkProps>
      name="CitationSourceLink"
      {...props}
    />
  );
};
